<script setup>
import { storeToRefs } from 'pinia';
import { useTopNavBarStore } from '@/store/topNavBar';
import NavBarTopMobilePrepend from '@/components/navbartop/NavBarTopMobilePrepend.vue';
import NavBarTopMobileAppend from '@/components/navbartop/NavBarTopMobileAppend.vue';

const store = useTopNavBarStore();

const {
  navTitle,
  extensionComponent,
  extensionHeight,
} = storeToRefs(store);
</script>

<template>
  <v-app-bar
    id="navbartop"
    scroll-behavior="elevate"
    class="d-flex align-content-space-evenly px-2"
    :extension-height="extensionHeight"
  >
    <template #prepend>
      <nav-bar-top-mobile-prepend />
    </template>

    <!-- Title -->
    <v-app-bar-title>
      <p class="small-text font-weight-medium">
        {{ navTitle }}
      </p>
    </v-app-bar-title>

    <template #append>
      <nav-bar-top-mobile-append />
    </template>

    <template #extension>
      <component :is="extensionComponent" class="extension" />
    </template>
  </v-app-bar>
</template>

<style scoped>
.small-text {
  font-size: 1.1rem !important;
}

.extension {
  margin-left: -8px;
  margin-right: -8px;
}
</style>
